
import React from 'react';
// material
import { Button, Card, CardHeader, CardContent, Divider, Modal } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Swal from 'sweetalert2';
// components
import Page from '../../componentes/Page';
import Iconify from '../../componentes/Iconify';
// mock
import RTabla from '../../componentes/tabla';
import CONFIG from '../../CONFIG.json';
import { buildBody, isEmpty, workWithLocalStorage, getUniqueKey, compruebaForm, limpiaObjeto } from '../../auxiliares/funciones';
import Formulario from './form/seriesform';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    minWidth: '750px',
    bgcolor: 'background.paper',
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
  };
// ----------------------------------------------------------------------

export default function Index(props) {
  const [lista, setLista] = React.useState([]);
  const [cargado, setCargado] = React.useState(false);
  const [key, setKey] = React.useState(getUniqueKey());

    const campos = ['serie','contador','anyo','tipoTexto','bccMail','estado'];    
    const cabecera = ['Nombre','Contador','Año','Tipo','Mail en Copia','Estado'];
    const usuario = workWithLocalStorage('get','usuario',null);

    React.useEffect(() => {
        async function cargaInicial(){
            if(!cargado){
                // eslint-disable-next-line react-hooks/exhaustive-deps
                const bodyJson = JSON.stringify(buildBody(CONFIG.TOKEN,{}))
                fetch(`${CONFIG.api}master/seriesfact`,{
                        method: 'POST',
                        body: bodyJson,
                        headers: {'Content-Type': 'application/json'}
                })
                .then(res => res.json())
                .then((result) => {
                    if (result.error === 0 && !isEmpty(result.data)) {
                    setLista(result.data);
                    }
                    setKey(getUniqueKey());
                    // eslint-disable-next-line react/prop-types
                    props.showLoader(false);            
                    setCargado(true);
                })
            }
        }
        cargaInicial();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[cargado]);

    const Form = {
        serie: '',
        tipo: null,
        anyo: null,
        bccMail: '',
        activo: 1,
      };
    const obligatorios = ['serie','tipo','anyo'];

    const tipos = [{id:0,nombre:'Débito'},{id:1,nombre:'Crédito'}];
    const anyos = [{id:2023,nombre:'2023'},{id:2024,nombre:'2024'},{id:2025,nombre:'2025'},{id:2026,nombre:'2026'},{id:2027,nombre:'2027'},{id:2028,nombre:'2028'},{id:2029,nombre:'2029'}];

    const [modalOpen, setModalOpen] = React.useState(false);
    const [serie, setSerie] = React.useState(Form);
    const cierraModal = () => setModalOpen(false);
    const abreModal = () => setModalOpen(true);

    const Actualiza = () =>{
        // eslint-disable-next-line react/prop-types
        props.showLoader(true); 
        // setCargado(false);
        setCargado(false)
    }

    const Borrar = (obj) =>{
        // eslint-disable-next-line react/prop-types
        props.showLoader(true); 
        const body = {
            tabla: "series_facturacion",
            activo: 0,
            usuario: usuario.id,
            id: obj.id
        }
        const bodyJson = JSON.stringify(buildBody(CONFIG.TOKEN,body))
        fetch(`${CONFIG.api}master/activo`,{
                    method: 'PUT',
                    body: bodyJson,
                    headers: {'Content-Type': 'application/json'}
            })
            .then(res => res.json())
            .then((result) => {
            let msg ='Serie desactivada!';
                if (result.error === 0) {    
                    setLista([]);               
                    setCargado(false);
                }else{
                    msg = result.errorMessage;
                }
                Swal.fire({
                    title: msg,
                    buttons: [{label: 'Ok'}]
                })
        })
    }

    const Activar = (obj) =>{
        // eslint-disable-next-line react/prop-types
        props.showLoader(true); 
        const body = {
            tabla: "series_facturacion",
            activo: 1,
            usuario: usuario.id,
            id: obj.id
        }
        const bodyJson = JSON.stringify(buildBody(CONFIG.TOKEN,body))
        fetch(`${CONFIG.api}master/activo`,{
                    method: 'PUT',
                    body: bodyJson,
                    headers: {'Content-Type': 'application/json'}
            })
            .then(res => res.json())
            .then((result) => {
            let msg ='Serie activada!';
                if (result.error === 0) {    
                    setLista([]);               
                    setCargado(false);
                }else{
                    msg = result.errorMessage;
                }
                Swal.fire({
                    title: msg,
                    buttons: [{label: 'Ok'}]
                })
        })
    }

    const altaSerie = (obj) =>{
        if(obj!==null){
            setSerie(obj);
        }else{
            setSerie(Form);
        }
        abreModal();
    }

    const actualizaCampo = (input) =>{
        const nombre = input.target.name
        const valor = input.target.value
        const comA = serie;
        comA[nombre] = valor
        setSerie(comA);
    }

    const Grabar = () =>{
        const serieF = limpiaObjeto(serie,Form,true)
        const valido = compruebaForm(Form,serieF,obligatorios);
        if(valido){
            // eslint-disable-next-line react/prop-types
            props.showLoader(true); 
            const body = serieF;
            body.idUsuarioAlta = usuario.id;
            body.idUsuarioMod = usuario.id;
            const bodyJson = JSON.stringify(buildBody(CONFIG.TOKEN,body))
            fetch(`${CONFIG.api}master/seriefact`,{
                    method: 'PUT',
                    body: bodyJson,
                    headers: {'Content-Type': 'application/json'}
            })
            .then(res => res.json())
            .then((result) => {
                let msg ='Serie grabada!';
                if (result.error === 0) { 
                    cierraModal();  
                    setCargado(false);
                }else{
                    props.showLoader(false); 
                    msg = result.errorMessage;
                }
                Swal.fire({
                    title: msg,
                    buttons: [{label: 'Ok'}]
                })
            })
        }else{
            Swal.fire({
                title: 'Revisa los campos con *',
                buttons: [{label: 'Ok'}]
            })
        }
    }

    const validaBorrar = (obj) => obj.activo === 1;
    const validaActivar = (obj) => obj.activo !== 1;

    const acciones = [
        {
          color:'info',
          nombre:'Editar',
          icono:<i />,
          funcion: altaSerie,
          estilo: {},
          condition: null
        },
        {
          color:'error',
          nombre:'Borrar',
          icono:<i />,
          funcion: Borrar,
          estilo: {},
          condition: validaBorrar
        },
        {
          color:'warning',
          nombre:'Activar',
          icono:<i />,
          funcion: Activar,
          estilo: {},
          condition: validaActivar
        }
      ]
    // FIN FUNCIONES DE LOS COMERCIALES ----------------------------------------

  return (    
    <Page title="Series de Facturación" key={lista.length}>
        <Card  sx={{ maxWidth: '100% !important'}}>
          <CardHeader action={<>
                                <Button variant="contained" color="primary" sx={{ color: 'white', marginRight: '15px'}} to="#" startIcon={<Iconify icon="eva:plus-fill" />}
                                onClick={()=>altaSerie(null)}>
                                  Alta
                                </Button>
                                <Button variant="contained" color="success" sx={{ color: 'white'}} to="#" startIcon={<Iconify icon="eva:refresh-fill" />}
                                onClick={()=>Actualiza()}>
                                  Actualizar
                                </Button>
                              </>}
                  title="Festivos"
          />
          <Divider style={{ margin: '15px'}} />
          <CardContent>
            <RTabla key={key} lista={lista} campos={campos} rowsPerPage={10} cabecera={cabecera} acciones={acciones}/>
          </CardContent>
        </Card>
        <Modal open={modalOpen} onClose={cierraModal} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
            <Card sx={style}>
                <CardHeader title={'Alta Serie'}
                action={<>
                    <Button variant="contained" color="primary" sx={{ color: 'white', marginRight: '15px'}} to="#" startIcon={<Iconify icon="eva:edit-outline" />}
                    onClick={()=>Grabar()}>
                        Grabar
                    </Button>
                    <CloseIcon fontSize="inherit" onClick={() => cierraModal() }/>
                </>}/>
                <Divider style={{ margin: '15px'}} />
                <CardContent>
                    <Formulario showLoader={props.showLoader} serie={serie} anyos={anyos} 
                        tipos={tipos} actualizaCampo={actualizaCampo}/>
                </CardContent>
            </Card>
        </Modal>
    </Page>
  );
}
